import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const FONT_SIZES = [
  'overline',
  'caption',
  'label',
  'body-sm',
  'body',
  'body-lg',
  'h4',
  'h3',
  'h2',
  'h1',
  'display',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...FONT_SIZES] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
